import React, { useEffect, useMemo, useRef, useState } from "react";
import type { ParamKeyValuePair } from "react-router-dom";
import {
  generatePath,
  Route,
  Routes,
  useNavigate,
  useParams,
  useSearchParams
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { head, last } from "lodash";
import {
  FileInput,
  GutterContainer,
  HeaderPage,
  Image as ImageComponent,
  ImageEnhancements,
  ItemTag,
  ItemTags,
  Keyline,
  Layout,
  Spacer,
  Tab,
  TabGroup,
  Toast
} from "@common/AggregationComponent";
import ProductTabNewFilter from "@common/NewFilter/ProductTabFilter";
import OutfitTabNewFilter from "@common/NewFilter/OutfitTabFilter";
import { isGUNativeApp } from "@util/nativeApp";
import {
  Bound,
  CATEGORY_TYPE,
  CombinedReducersType,
  GeneratePath,
  GetOutfitArgs,
  GetProductsArgs,
  OUTFIT_SORT,
  OutfitDetail,
  OutfitHeight,
  Point,
  PORDUCT_SORT,
  ProductDetail,
  ProductDetailGrid,
  ProductInfoType,
  RESULT_TAB,
  SelectedGender,
  Size
} from "@type/index";
import {
  AppActions,
  ImageSearchActions,
  SearchResultActions,
  FeedbackActions
} from "@redux/reducer";
import { useDispatch, useSelector } from "react-redux";
import {
  base64ToFile,
  changeFileType,
  computedSafePoint,
  fileToBase64,
  formatTotalNum,
  getBrand,
  getBrandForMeta,
  getRegionFromUrl,
  getUrlParamaObjCustom,
  handleDuplicate,
  handleHeightLabel,
  handleMoreSizeCodeToLessSize,
  handleOneSizeFormatMore,
  handleSelectGenderHeight,
  handleSelectSizeToUrl,
  transformBrandForGoogleAnalytics,
  getIsLoggedIn,
  getEcRenewalCompatibility,
  isNotEmptyObj
} from "@util/common";
import { isIOS, isSafari as isSafariBrowser } from "react-device-detect";
import imageOnLoad from "@util/uploadImage";
import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";
import { getVisualSearchMinScoreConfig } from "@util/firebase";
import getProductTabFilterPillContent from "@common/NewFilter/ProductTabFilter/FilterPill";
import getOutfitTabFilterPillContent from "@common/NewFilter/OutfitTabFilter/FilterPill";
import {
  GENDER_BABY_ID_EU_UQ,
  GENDER_BABY_ID_JP_UQ,
  GENDER_BABY_ID_UK_UQ,
  GENDER_BABY_ID_US_UQ,
  GENDER_KIDS_BABY_ID_JP_GU,
  GENDER_KIDS_ID_EU_UQ,
  GENDER_KIDS_ID_JP_UQ,
  GENDER_KIDS_ID_UK_UQ,
  GENDER_KIDS_ID_US_UQ,
  GENDER_MEN_ID_EU_UQ,
  GENDER_MEN_ID_JP_GU,
  GENDER_MEN_ID_JP_UQ,
  GENDER_MEN_ID_UK_UQ,
  GENDER_MEN_ID_US_UQ,
  GENDER_WOMEN_ID_EU_UQ,
  GENDER_WOMEN_ID_JP_GU,
  GENDER_WOMEN_ID_JP_UQ,
  GENDER_WOMEN_ID_UK_UQ,
  GENDER_WOMEN_ID_US_UQ,
  IS_SHOW_OUTFIT_WISH_ICON,
  MIN_SCORE
} from "@util/config";
import {
  sendTrackEvent,
  TRACK_EVENT,
  TRACK_EVENT_SEARCH,
  trackSearchClickEvent
} from "@util/gtm";
import ProductList from "./ProductList";
import OutfitList from "./OutfitList";
import LoginModal from "../../common/LoginModal";
import FavoritesPopup from "../../common/FavoritesPopup";
import ServerErrorModal from "../../common/ServerErrorModal";
import withBreadcrumb from "../../hoc/withBreadcrumb";
// import ItemFilter from "./ProductList/components/PcFilter";
// import OutfitFilter from "./OutfitList/components/PcFilter/index";
// import OutfitFilter from "./OutfitList/components/PcFilter/index";
import style from "./style.module.scss";
import FilterModel from "./ProductList/components/FilterModel";
import OutfitFilterModel from "./OutfitList/components/FilterModel";
import { HeightOptions } from "./genderHeightConfig";
// import GoTop from "../../common/GoTop";
import NoResult from "../../common/NoResult";
import UploadServerErrorModel from "../../common/UploadServerErrorModel";
import FeedBackModal from "../../common/FeedBackModal";
// page type
const typeList: string[] = [RESULT_TAB.ITEM, RESULT_TAB.OUTFIT];
// 25 of per page
const PAGE_NUM = 25;
const INDEX_PAGE = 1;
let defaultPathname = "";
let defaultSearch = "";
let isClickSizeCheckList = false;
// outfit gender
// 1.MEN 2.WOMEN 3.KIDS 4.BABY
const OUTFIT_GENDER: any = {
  MEN: 1,
  WOMEN: 2,
  KIDS: 3,
  BABY: 4
};
const SIZE_SORT_CONFIG = [
  // EC no have SMA
  "SMA",
  "NKC",
  "BSC",
  "KSS",
  "INS",
  "CMB",
  "CMD",
  "BUW",
  "JKC",
  "CMA",
  "CMC",
  "FBJ",
  "BRJ",
  // EC no have SII SIZ
  "SII",
  "SIZ"
];
const GENDER_DICT: any = {
  UQ: {
    JP: {
      WOMEN: GENDER_WOMEN_ID_JP_UQ,
      MEN: GENDER_MEN_ID_JP_UQ,
      KIDS: GENDER_KIDS_ID_JP_UQ,
      BABY: GENDER_BABY_ID_JP_UQ
    },
    US: {
      WOMEN: GENDER_WOMEN_ID_US_UQ,
      MEN: GENDER_MEN_ID_US_UQ,
      KIDS: GENDER_KIDS_ID_US_UQ,
      BABY: GENDER_BABY_ID_US_UQ
    },
    UK: {
      WOMEN: GENDER_WOMEN_ID_UK_UQ,
      MEN: GENDER_MEN_ID_UK_UQ,
      KIDS: GENDER_KIDS_ID_UK_UQ,
      BABY: GENDER_BABY_ID_UK_UQ
    },
    EU: {
      WOMEN: GENDER_WOMEN_ID_EU_UQ,
      MEN: GENDER_MEN_ID_EU_UQ,
      KIDS: GENDER_KIDS_ID_EU_UQ,
      BABY: GENDER_BABY_ID_EU_UQ
    }
  },
  GU: {
    JP: {
      WOMEN: GENDER_WOMEN_ID_JP_GU,
      MEN: GENDER_MEN_ID_JP_GU,
      KIDS_BABY: GENDER_KIDS_BABY_ID_JP_GU
    }
  }
};

enum TAG_TYPE {
  SIZE = "size",
  CATEGORY = "category"
}

// sort
enum SORT_CONFIG {
  DESC = -1,
  ASC = 1
}

const SearchResult = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [cookies, setCookie] = useCookies(["tagName"]);
  const [jumpCookies, setJumpFrom] = useCookies(["jumpFrom"]);
  const [searchType, setSearchType] = useState<string>(
    params["*"] || RESULT_TAB.ITEM
  );
  const [imgUrl, setImgUrl] = useState<string>("");
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedSizes, setSelectedSizes] = useState<any[]>([]);
  const [selectedCategories, setSelectedCategories] = useState<any[]>([]);
  const [selectedOutfitGender, setSelectedOutfitGender] =
    useState<SelectedGender>("All");
  const [selectedOutfitHeight, setSelectedOutfitHeight] = useState<
    string | any
  >("");
  const [allowFileTypes] = useState<string[]>([
    "image/jpg",
    "image/jpeg",
    "image/png",
    "image/webp",
    "image/gif"
  ]);
  // tag label wording
  const [tagWordingDict, setTagWordingDict] = useState<any>({});
  const [isPopupShown, setIsPopupShown] = useState<boolean>(false);
  const [currentItemInfo, setCurrentItemInfo] = useState({
    productInfo: {} as ProductInfoType,
    styleId: ""
  });
  useEffect(() => {
    setTagWordingDict({
      tops: t("text_image_search_category_tops"),
      outerwears: t("text_image_search_category_outerwears"),
      dress: t("text_image_search_category_dress"),
      bottoms: t("text_image_search_category_bottoms"),
      skirts: t("text_image_search_category_skirts"),
      shoes: t("text_image_search_category_shoes"),
      sandal: t("text_image_search_category_sandal"),
      eyewear: t("text_image_search_category_eyewear"),
      bags: t("text_image_search_category_bags"),
      accessories: t("text_image_search_category_accessories"),
      hats: t("text_image_search_category_hats")
    });
    defaultPathname = location.pathname;
    defaultSearch = location.search;
  }, [t]);
  const handleGenderHeights = () =>
    HeightOptions[`${params.language}-${params.region}`] ||
    HeightOptions["en-eu"];

  const genderHeights = useRef<any>(handleGenderHeights());
  const [visibleFilterModal, setVisibleFilterModal] = useState<boolean>(false);
  const [visibleOutfitFilterModal, setVisibleOutfitFilterModal] =
    useState<boolean>(false);
  const [productIds, setProductIds] = useState<string[]>([]);
  const paramImage = useSelector(
    (state: CombinedReducersType) => state.imageSearch.image
  );
  const isClickUploadImage: boolean = useSelector(
    (state: CombinedReducersType) => state.imageSearch.isClickUploadImage
  );
  const isUploadImageLoading: boolean = useSelector(
    (state: CombinedReducersType) => state.imageSearch.isUploadImageLoading
  );
  const appStore = useSelector((state: CombinedReducersType) => state.app);
  const searchResult = useSelector(
    (state: CombinedReducersType) => state.searchResult
  );
  const feedbackStore = useSelector(
    (state: CombinedReducersType) => state.feedback
  );
  const [productName, setProductName] = useState<string>(
    searchResult.bounds[0] ? searchResult.bounds[0].selectedName : ""
  );
  const outfitPage = useRef<number>(1);
  const [productSort, setProductSort] = useState<string>(PORDUCT_SORT.SIMILAR);
  const [outfitSort] = useState<string>(OUTFIT_SORT.RECENCY);
  const [isClickProductTabSort, setIsClickProductTabSort] =
    useState<boolean>(false);
  const [isClickOutfitTabSort, setIsClickOutfitTabSort] =
    useState<boolean>(false);
  const [visibleCategory, setVisibleCategory] = useState<boolean>(false);
  const [visibleSize, setVisibleSize] = useState<boolean>(false);
  const [visibleGender, setVisibleGender] = useState<boolean>(false);
  const [visibleHeight, setVisibleHeight] = useState<boolean>(false);
  const [isImageLoad, setIsImageLoad] = useState<boolean>(false);
  const [filteredSizes, setFilteredSizes] = useState<any[]>([]);
  // for outfit color
  const visualProducts = useRef<any[]>([]);
  // set default min_score
  const minScore = useRef<string>(MIN_SCORE);
  // set default imageSearch_wish is show or not
  const isShowOutfitWishIcon = useRef<boolean>(IS_SHOW_OUTFIT_WISH_ICON);
  const selectedTagName = useRef("");
  const isSearchTypeFirst = useRef(true);
  const utilityBarScrollTop = useRef<number>(0);
  const productsShouldResetScroll = useRef(false);
  const outfitsShouldResetScroll = useRef(false);
  const lastProductCategoriesLength = useRef(0);
  const [isFilterOpening, setIsFilterOpening] = useState<boolean>(false);
  const [isOutfitFilterOpening, setIsOutfitFilterOpening] =
    useState<boolean>(false);

  const BASE_PATH_NAME = `/${appStore.region}/${appStore.language}`;

  const setIsClickSizeCheckList = (value: boolean) => {
    isClickSizeCheckList = value;
  };

  const setSortFilteredSizes = (sizes: Size[]) => {
    // sort sizes
    const newSizes: Size[] = [...sizes].sort((sizeA: Size, sizeB: Size) => {
      const sizeAIndex = SIZE_SORT_CONFIG.findIndex(
        (item: string) => sizeA.code.indexOf(item) > -1
      );
      const sizeBIndex = SIZE_SORT_CONFIG.findIndex(
        (item: string) => sizeB.code.indexOf(item) > -1
      );
      if (sizeAIndex > -1) {
        if (sizeBIndex > -1) {
          return sizeAIndex - sizeBIndex;
        } else {
          return SORT_CONFIG.DESC;
        }
      }
      return SORT_CONFIG.ASC;
    });
    setFilteredSizes(handleDuplicate(newSizes, "name"));
  };
  const imageLoaded = () => {
    setIsImageLoad(true);
    const HEADER_BAR_HEIGHT = appStore.isApp ? 0 : 65;
    const TAG_GROUP_HEIGHT = 55;
    const SORT_TAB_HEIGHT = 45;
    const tabGroup: HTMLDivElement | null =
      document.querySelector(".fr-ec-tab-group");
    if (tabGroup && tabGroup.offsetTop) {
      utilityBarScrollTop.current =
        tabGroup.offsetTop -
        HEADER_BAR_HEIGHT +
        TAG_GROUP_HEIGHT +
        SORT_TAB_HEIGHT;
    }
  };
  const handleChangeProductTab = () => {
    if (searchType !== RESULT_TAB.ITEM) {
      setSearchType(RESULT_TAB.ITEM);
      const url = generatePath("/:region/:language/image-search/search/:type", {
        ...params,
        type: RESULT_TAB.ITEM
      } as GeneratePath);
      navigate(url);
    }
  };
  const getProductItemColorIds = (result = searchResult.result): string[] => {
    if (
      searchResult.visualProducts.length > 0 &&
      selectedTagName.current !== ""
    ) {
      const currentProducts = searchResult.visualProducts.find(
        (product: any) => product.selectedName === selectedTagName.current
      );
      if (currentProducts) {
        visualProducts.current = currentProducts.similar_products;
      }
    }
    return result.items
      .map((item: ProductDetailGrid) => {
        let productId = "";
        if (visualProducts.current.length > 0) {
          const info = visualProducts.current.find(
            (product: any) => product.upstream_product_id === item.productId
          );
          if (info && info.color_code) {
            productId = `${item.productId}-${info.color_code}`;
          }
        }
        return productId;
      })
      .filter((item: string) => item !== "");
  };

  const handleChangeStylingTab = () => {
    if (searchType !== RESULT_TAB.OUTFIT) {
      setSearchType(RESULT_TAB.OUTFIT);
      const url = generatePath("/:region/:language/image-search/search/:type", {
        ...params,
        type: RESULT_TAB.OUTFIT
      } as GeneratePath);
      navigate(url);
    }
  };
  /**
   * update products
   * @param sizes filter size
   * @param paths filter category
   * @param prodIds product ids
   * @param sort sort
   * @param resetOutfit reset outfit filter && page
   */
  const updateProducts = (
    sizes: string[] = [],
    paths: string[] = [],
    prodIds: string[],
    sort: number = parseInt(productSort, 10),
    resetOutfit = false
  ) => {
    const _sizes = handleOneSizeFormatMore(
      searchResult.result.aggregations.sizes,
      sizes
    );
    if (prodIds.length > 0) {
      const fetchProductsParams: GetProductsArgs = {
        productsIds: prodIds,
        path: paths,
        sizeCodes: _sizes,
        sort,
        callback: (
          sizess: any[],
          tree: any[],
          result: any,
          categoryType: string | undefined
        ) => {
          if (categoryType || categoryType === "") {
            dispatch(SearchResultActions.setCategoryType(categoryType));
          }
          // update outfit
          // reset page
          outfitPage.current = INDEX_PAGE;
          if (resetOutfit) {
            fetchOutfits(getProductItemColorIds(result), "All", "", true);
          } else {
            fetchOutfits(
              getProductItemColorIds(result),
              selectedOutfitGender,
              selectedOutfitHeight.value,
              true
            );
          }
        }
      };
      dispatch(SearchResultActions.fetchProducts(fetchProductsParams));
    }
  };

  const getSearchCategories = (): any[] =>
    searchParams.get("catId")?.split(",") || [];
  const getSearchSizes = (): any[] =>
    searchParams.get("sizeCodes")?.split(",") || [];
  const getSearchSort = () => (searchParams.get("sort") === "1" ? 1 : -1);
  const getSearchGender = (): string => searchParams.get("gender") || "";
  const getSearchHeight = (): string => searchParams.get("height") || "";
  // for GA
  useEffect(() => {
    if (searchType === RESULT_TAB.OUTFIT) {
      return;
    }
    if (searchResult.result.pagination.total > 0) {
      // item Categories
      const searchCategories = getSearchCategories();
      const treeMore = Object.values(searchResult.result.aggregations.tree);
      const tree: any = [];
      treeMore.forEach((item: any) => {
        item.forEach((items: any) => {
          tree.push(items);
        });
      });
      // Categories
      let newSelectedCategories: any[] = getSelectedSearchCategories(
        searchCategories,
        tree
      );
      newSelectedCategories = newSelectedCategories.map((item) => item.name);
      // item sizes
      const searchSizes = getSearchSizes();
      const sizes = searchResult.result.aggregations.sizes;
      let newSelectedSizes: any[] = [];
      searchSizes.forEach((searchSizeCode: any) => {
        sizes.forEach((size: any) => {
          if (searchSizeCode === size.code) {
            newSelectedSizes.push(size);
          }
        });
      });
      newSelectedSizes = newSelectedSizes.map((item) => item.name);
      if (newSelectedCategories.length > 0 && newSelectedSizes.length > 0) {
        sendTrackEvent({
          brand: transformBrandForGoogleAnalytics(appStore.brand_name),
          event: TRACK_EVENT_SEARCH,
          eventAction: "IS_Item_WithFilter",
          eventCategory: "IS_Result",
          eventLabel: `Search term: ${newSelectedCategories.join(
            ","
          )},${newSelectedSizes.join(",")}`,
          searchTerm: `${newSelectedCategories.join(
            ","
          )},${newSelectedSizes.join(",")}`,
          resultsNumber: `${searchResult.result.pagination.total}`
        });
      } else if (newSelectedCategories.length > 0) {
        sendTrackEvent({
          brand: transformBrandForGoogleAnalytics(appStore.brand_name),
          event: TRACK_EVENT_SEARCH,
          eventAction: "IS_Item_WithFilter",
          eventCategory: "IS_Result",
          eventLabel: `Search term: ${newSelectedCategories.join(",")}`,
          searchTerm: `${newSelectedCategories.join(",")}`,
          resultsNumber: `${searchResult.result.pagination.total}`
        });
      } else if (newSelectedSizes.length > 0) {
        sendTrackEvent({
          brand: transformBrandForGoogleAnalytics(appStore.brand_name),
          event: TRACK_EVENT_SEARCH,
          eventAction: "IS_Item_WithFilter",
          eventCategory: "IS_Result",
          eventLabel: `Search term: ${newSelectedSizes.join(",")}`,
          searchTerm: `${newSelectedSizes.join(",")}`,
          resultsNumber: `${searchResult.result.pagination.total}`
        });
      } else {
        sendTrackEvent({
          brand: transformBrandForGoogleAnalytics(appStore.brand_name),
          event: TRACK_EVENT_SEARCH,
          eventAction: "IS_Item_WithoutFilter",
          eventCategory: "IS_Result",
          eventLabel: "Search term:",
          searchTerm: null,
          resultsNumber: `${searchResult.result.pagination.total}`
        });
      }
    } else if (
      !searchResult.result.initFlag &&
      searchResult.result.pagination.total === 0
    ) {
      sendTrackEvent({
        brand: transformBrandForGoogleAnalytics(appStore.brand_name),
        event: TRACK_EVENT,
        eventAction: "IS_Item_NotFound",
        eventCategory: "IS_Result",
        eventLabel: "Search term:"
      });
    }
  }, [searchResult.resultForGa]);
  useEffect(() => {
    if (searchType !== RESULT_TAB.OUTFIT) {
      return;
    }
    if (searchResult.outFitResult.total > 0) {
      const searchGender: string = getSearchGender();
      const searchHeight = getSearchHeight();
      const fetchParams: { gender: SelectedGender; height: string } = {
        gender: "All",
        height: ""
      };
      if (searchGender && searchGender !== "All") {
        fetchParams.gender = searchGender as SelectedGender;
      }
      if (searchHeight) {
        const heights = searchGender
          ? genderHeights.current[
              handleSelectGenderHeight(searchGender) as SelectedGender
            ]
          : genderHeights.current.All;
        if (heights.length > 0) {
          const height = heights.find((item: any) => {
            const isJpJa = params.region === "jp" && params.language === "ja";
            const minHeight = item.min ? item.min : "1";
            let maxHeight;
            if (!item.max && isJpJa) {
              maxHeight = "300";
            } else if (!item.max && !isJpJa) {
              maxHeight = "118";
            } else {
              maxHeight = item.max;
            }
            return `${minHeight}-${maxHeight}` === searchHeight;
          });
          if (height) {
            fetchParams.height = handleHeightLabel(height, t);
          }
        }
      }
      if (fetchParams.gender !== "All" && fetchParams.height) {
        sendTrackEvent({
          brand: transformBrandForGoogleAnalytics(appStore.brand_name),
          event: TRACK_EVENT_SEARCH,
          eventAction: "IS_Outfit_WithFilter",
          eventCategory: "OS_Result",
          eventLabel: `Search term: ${fetchParams.gender},${fetchParams.height}`,
          searchTerm: `${fetchParams.gender},${fetchParams.height}`,
          resultsNumber: `${searchResult.outFitResult.total}`
        });
      } else if (fetchParams.gender !== "All") {
        sendTrackEvent({
          brand: transformBrandForGoogleAnalytics(appStore.brand_name),
          event: TRACK_EVENT_SEARCH,
          eventAction: "IS_Outfit_WithFilter",
          eventCategory: "OS_Result",
          eventLabel: `Search term: ${fetchParams.gender}`,
          searchTerm: `${fetchParams.gender}`,
          resultsNumber: `${searchResult.outFitResult.total}`
        });
      } else if (fetchParams.height) {
        sendTrackEvent({
          brand: transformBrandForGoogleAnalytics(appStore.brand_name),
          event: TRACK_EVENT_SEARCH,
          eventAction: "IS_Outfit_WithFilter",
          eventCategory: "OS_Result",
          eventLabel: `Search term: ${fetchParams.height}`,
          searchTerm: `${fetchParams.height}`,
          resultsNumber: `${searchResult.outFitResult.total}`
        });
      } else {
        sendTrackEvent({
          brand: transformBrandForGoogleAnalytics(appStore.brand_name),
          event: TRACK_EVENT_SEARCH,
          eventAction: "IS_Outfit_WithoutFilter",
          eventCategory: "OS_Result",
          eventLabel: "Search term:",
          searchTerm: null,
          resultsNumber: `${searchResult.outFitResult.total}`
        });
      }
    } else if (
      !searchResult.result.initFlag &&
      searchResult.outFitResult.total === 0
    ) {
      sendTrackEvent({
        brand: transformBrandForGoogleAnalytics(appStore.brand_name),
        event: TRACK_EVENT,
        eventAction: "IS_Outfit_NotFound",
        eventCategory: "OS_Result",
        eventLabel: "Search term:"
      });
    }
  }, [searchResult.outFitResult]);
  useEffect(() => {
    if (searchResult.result.initFlag) {
      return;
    }
    sendTrackEvent({
      brand: transformBrandForGoogleAnalytics(appStore.brand_name),
      event: TRACK_EVENT,
      eventAction: "IS_Item_NotFound",
      eventCategory: "IS_Result",
      eventLabel: "Search term:"
    });
  }, [searchResult.visualSearchNoData]);

  const getSelectedSearchCategories = (
    searchCategories: any[],
    tree: any[]
  ) => {
    const newSelectedCategories: string[] = [];
    searchCategories.forEach((categoryId: string) => {
      tree.forEach((categoryInfo: any) => {
        if (categoryInfo.id === parseInt(categoryId, 10)) {
          newSelectedCategories.push(categoryInfo);
        }
      });
    });
    return newSelectedCategories;
  };

  const initSelectedTags = (
    sizes: any[],
    tree: any[],
    result: any,
    categoryType: string | undefined
  ) => {
    // init filter selected tags
    const searchCategories = getSearchCategories();
    const searchSizes = getSearchSizes();
    const searchSort = getSearchSort();
    if (categoryType || categoryType === "") {
      dispatch(SearchResultActions.setCategoryType(categoryType));
    }
    if (searchCategories.length > 0) {
      const newSelectedCategories = getSelectedSearchCategories(
        searchCategories,
        tree
      );

      if (newSelectedCategories.length > 0) {
        setSelectedCategories(newSelectedCategories);
      }
    }
    if (searchSizes.length > 0) {
      const newSelectedSizes: string[] = [];
      searchSizes.forEach((searchSizeCode: any) => {
        sizes.forEach((size: any) => {
          if (searchSizeCode === size.code) {
            newSelectedSizes.push(size);
          }
        });
      });
      if (newSelectedSizes.length > 0) {
        setSelectedSizes(newSelectedSizes);
      }
    }
    if (searchSort === 1) {
      setProductSort(PORDUCT_SORT.RECENCY);
    }
    // init outfit params
    const searchGender: string = getSearchGender();
    const searchHeight = getSearchHeight();
    const fetchParams: { gender: SelectedGender; height: string } = {
      gender: "All",
      height: ""
    };
    if (searchGender && searchGender !== "All") {
      fetchParams.gender = searchGender as SelectedGender;
      setSelectedOutfitGender(searchGender as SelectedGender);
    }
    if (searchHeight) {
      const heights = searchGender
        ? genderHeights.current[
            handleSelectGenderHeight(searchGender) as SelectedGender
          ]
        : genderHeights.current.All;
      if (heights.length > 0) {
        const height = heights.find(
          (item: any) =>
            Number(item.value) === Number(searchHeight.replace("-", ""))
        );
        if (height) {
          fetchParams.height = height.value;
          setSelectedOutfitHeight(height);
        }
      }
    }
    // fetch outfit
    fetchOutfits(
      getProductItemColorIds(result),
      fetchParams.gender,
      fetchParams.height,
      true,
      result.aggregations.tree.genders
    );
  };
  const goTopPage = () => {
    window.scrollTo(0, 0);
  };
  const scrollToUtilityBar = () => {
    if (utilityBarScrollTop.current) {
      setTimeout(() => {
        window.scrollTo(0, utilityBarScrollTop.current);
      }, 300);
    }
  };
  const handlerChangeSelectedSizes = (sizes: string[]) => {
    productsShouldResetScroll.current = true;
    // goTopPage();
    setSelectedSizes(sizes);
    setProductFilter(sizes, selectedCategories, productSort, true);
    if (sizes.length > 0) {
      setVisibleSize(true);
    }
    updateProducts(
      sizes.map((size: any) => size.code),
      getSearchCategories(),
      productIds
    );
    handlerChangeFilter();
  };
  const unCheckSizes = () => {
    if (filteredSizes.length > 0) {
      const newFilterdSizes = filteredSizes.map((size: any) => ({
        ...size,
        checked: false
      }));
      setFilteredSizes([...newFilterdSizes]);
    }
  };
  const handlerClearAllItemFilter = () => {
    unCheckSizes();
    setSelectedSizes([]);
    setSelectedCategories([]);
    updateProducts([], [], productIds);
    setProductFilter([], [], productSort, true);
  };
  const resetProductCategoriesLength = () => {
    lastProductCategoriesLength.current = 0;
  };
  const handlerSelectedCategories = (categories: string[]) => {
    productsShouldResetScroll.current = true;
    setSelectedCategories(categories);
    // goTopPage();
    const isResetOutfit =
      (lastProductCategoriesLength.current === 0 && categories.length === 1) ||
      (lastProductCategoriesLength.current > 0 && categories.length === 0);
    // delete or change category (gender) reset outfit filter
    if (isResetOutfit) {
      setSelectedOutfitHeight("");
      setSelectedOutfitGender("All");
    }
    setProductFilter(selectedSizes, categories, productSort, true);
    updateProducts(
      getSearchSizes(),
      categories.map((category: any) => category.id),
      productIds,
      parseInt(productSort, 10),
      isResetOutfit
    );
    lastProductCategoriesLength.current = categories.length;
    handlerChangeFilter();
  };
  useEffect(() => {
    if (selectedSizes.length > 0) {
      // Get intersection
      const currentSizes = searchResult.result.aggregations.sizes;
      const intersectionSizes: any[] = [];
      selectedSizes.forEach((item: any) => {
        currentSizes.forEach((size: any) => {
          if (item.code === size.code) {
            intersectionSizes.push(item);
          }
        });
      });
      setSelectedSizes([...intersectionSizes]);
      setProductFilter(
        [...intersectionSizes],
        selectedCategories,
        productSort,
        true
      );
    }
  }, [searchResult.result.aggregations.sizes.length]);
  const handlerOutfitSelected = (
    gender: SelectedGender,
    height: any,
    chooseGender: boolean
  ) => {
    outfitsShouldResetScroll.current = true;
    // goTopPage();
    const all = [gender || "", handleHeightLabel(height, t) || ""];
    // if click gender then set flag for error wording
    dispatch(SearchResultActions.setChangedOutfitFilterFlag(true));
    // dispatch(SearchResultActions.clearOutfits());
    if (chooseGender) {
      sendTrackEvent({
        brand: transformBrandForGoogleAnalytics(appStore.brand_name),
        event: TRACK_EVENT_SEARCH,
        eventAction: "ImageOutfitSearch",
        eventLabel: `${gender || ""}`,
        eventCategory: "OS_Item_Filter",
        genderFilter: gender || null,
        heightFilter: null
      });
    } else {
      sendTrackEvent({
        brand: transformBrandForGoogleAnalytics(appStore.brand_name),
        event: TRACK_EVENT_SEARCH,
        eventAction: "ImageOutfitSearch",
        eventLabel: `${all.join(",")}`,
        eventCategory: "OS_Item_Filter",
        genderFilter: gender || null,
        heightFilter: handleHeightLabel(height, t) || null
      });
    }
    // gender changed
    if (selectedOutfitGender !== gender) {
      outfitPage.current = INDEX_PAGE;
      setSelectedOutfitGender(gender);
      if (gender === "All") {
        setSelectedOutfitHeight(height);
        setOutfitFilter("All", height, true);
        fetchOutfits(getProductItemColorIds(), "All", height.value || "", true);
      } else {
        setSelectedOutfitHeight("");
        setOutfitFilter(gender, "", true);
        fetchOutfits(getProductItemColorIds(), gender, "", true);
      }
      // height changed
    } else if (height === "" || selectedOutfitHeight.value !== height.value) {
      outfitPage.current = INDEX_PAGE;
      setSelectedOutfitHeight(height);
      setOutfitFilter(gender, height, true);
      fetchOutfits(getProductItemColorIds(), gender, height.value, true);
    }
  };
  const handlerSizeExpand = () => {
    setVisibleSize(!visibleSize);
  };
  const handlerCategoryExpand = () => {
    setVisibleCategory(!visibleCategory);
  };
  const handlerGenderExpand = () => {
    setVisibleGender(!visibleGender);
  };
  const handlerHeightExpand = () => {
    setVisibleHeight(!visibleHeight);
  };
  // const getPcFilter = () => {
  //   if (!searchResult.visualSearchNoData) {
  //     return searchType === RESULT_TAB.ITEM ? (
  //       <ItemFilter
  //         visible={
  //           !(
  //             searchResult.result.pagination.count === 0 &&
  //             selectedCategories.length === 0 &&
  //             selectedSizes.length === 0
  //           )
  //         }
  //         isLoading={searchResult.resultItemloading}
  //         tree={searchResult.result.aggregations.tree}
  //         sizes={filteredActivedSizes}
  //         visibleSize={visibleSize}
  //         visibleCategory={visibleCategory}
  //         searchCategories={getSearchCategories()}
  //         searchSizes={getSearchSizes()}
  //         categoryType={searchResult.categoryType}
  //         selectedSizes={selectedSizes}
  //         filteredSizes={filteredSizes}
  //         selectedCategories={selectedCategories}
  //         onChangeSelectedSizes={handlerChangeSelectedSizes}
  //         onChangeSelectedCategories={handlerSelectedCategories}
  //         handlerSizeExpand={handlerSizeExpand}
  //         handlerCategoryExpand={handlerCategoryExpand}
  //         handlerClearAllFilter={handlerClearAllItemFilter}
  //         setFilteredSizes={setSortFilteredSizes}
  //         setIsClickSizeCheckList={setIsClickSizeCheckList}
  //       />
  //     ) : (
  //       <OutfitFilter
  //         visible={
  //           !(
  //             searchResult.outFitResult.total === 0 &&
  //             selectedOutfitGender === "All" &&
  //             selectedOutfitHeight === ""
  //           )
  //         }
  //         genders={getOutfitGenders()}
  //         heights={getOutfitHeights()}
  //         visibleGender={visibleGender}
  //         visibleHeight={visibleHeight}
  //         selectedGender={selectedOutfitGender}
  //         selectedHeight={selectedOutfitHeight}
  //         onChangeSelected={handlerOutfitSelected}
  //         handlerGenderExpand={handlerGenderExpand}
  //         handlerHeightExpand={handlerHeightExpand}
  //       />
  //     );
  //   } else {
  //     return <></>;
  //   }
  // };
  const handlerToggleFilter = () => {
    setVisibleFilterModal(true);
    setIsFilterOpening(true);
  };
  const handlerToggleOutfitFilter = () => {
    setVisibleOutfitFilterModal(!visibleOutfitFilterModal);
    setIsOutfitFilterOpening(!isOutfitFilterOpening);
  };
  const handlerChangeSort = (sort: string) => {
    dispatch(SearchResultActions.setChangedItemSortFlag(true));
    // goTopPage();
    switch (sort) {
      case PORDUCT_SORT.SIMILAR:
        updateProducts(
          getSearchSizes(),
          getSearchCategories(),
          productIds,
          parseInt(PORDUCT_SORT.SIMILAR, 10)
        );
        setProductSort(PORDUCT_SORT.SIMILAR);
        setProductFilter(
          selectedSizes,
          selectedCategories,
          PORDUCT_SORT.SIMILAR,
          true
        );
        break;
      case PORDUCT_SORT.RECENCY:
        updateProducts(
          getSearchSizes(),
          getSearchCategories(),
          productIds,
          parseInt(PORDUCT_SORT.RECENCY, 10)
        );
        setProductSort(PORDUCT_SORT.RECENCY);
        setProductFilter(
          selectedSizes,
          selectedCategories,
          PORDUCT_SORT.RECENCY,
          true
        );
        break;
      default:
        break;
    }
  };
  const handlerChangeFilter = () => {
    dispatch(SearchResultActions.setChangedItemFilterFlag(true));
  };
  const handlerChangeOutfitSort = () => {
    dispatch(SearchResultActions.setChangedOutfitSortFlag(true));
    // goTopPage();
    dispatch(AppActions.setOutfitChangeOrderFlag(true));
    outfitPage.current = INDEX_PAGE;
    dispatch(SearchResultActions.clearOutfits());
    fetchOutfits(
      getProductItemColorIds(),
      selectedOutfitGender,
      selectedOutfitHeight.value,
      true
    );
    setOutfitFilter(selectedOutfitGender, selectedOutfitHeight, true);
  };
  const handlerClickStyleFavorite = (outfit: OutfitDetail) => {
    if (!getIsLoggedIn() && !isGUNativeApp()) {
      dispatch(AppActions.setLoginModal(true));
    } else {
      if (!outfit.favorite) {
        sendTrackEvent({
          brand: transformBrandForGoogleAnalytics(appStore.brand_name),
          event: TRACK_EVENT,
          eventAction: "add_to_wishlist",
          eventCategory: "is_wishlist_style", // IS_stylehint_Wishlist_style IS_stylehint_Wishlist_style
          eventLabel: `${outfit.outfitType}:${outfit.styleId}`
        });
      } else {
        sendTrackEvent({
          brand: transformBrandForGoogleAnalytics(appStore.brand_name),
          event: TRACK_EVENT,
          eventAction: "remove_from_wishlist",
          eventCategory: "is_wishlist_style", // IS_stylehint_Wishlist_style IS_stylehint_Wishlist_style
          eventLabel: `${outfit.outfitType}:${outfit.styleId}`
        });
      }
      dispatch(SearchResultActions.setOutfitFavorite(outfit));
    }
  };
  const handlerFavoriteClick = (product: ProductDetail, index: number) => {
    if (!getIsLoggedIn() && !isGUNativeApp()) {
      dispatch(AppActions.setLoginModal(true));
    } else {
      const getPriceValue = (): number | null => {
        if (isNotEmptyObj(product.prices)) {
          return !product.prices.promo
            ? product.prices.base?.value || null
            : product.prices.promo?.value || null;
        } else {
          return null;
        }
      };
      setIsPopupShown(true);
      setCurrentItemInfo({
        productInfo: {
          genderCategory: product.genderCategory,
          sizeGender: product.sizeGender,
          l1Id: product.l1Id,
          name: product.name,
          priceGroup: product.priceGroup,
          price: getPriceValue() ?? 0,
          currency: product.prices.base.currency.code,
          productId: product.productId,
          size: product.representative.size,
          color: product.representative.color,
          index: index
        },
        styleId: product.representative.l2Id
      });
    }
  };
  const closeFilterModel = () => {
    // scroll go top when close filter modal
    if (productsShouldResetScroll.current) {
      scrollToUtilityBar();
      productsShouldResetScroll.current = false;
    }
    setVisibleFilterModal(false);
    setIsFilterOpening(false);
  };
  const closeOutfitFilterModel = () => {
    // scroll go top when close filter modal
    if (outfitsShouldResetScroll.current) {
      scrollToUtilityBar();
      outfitsShouldResetScroll.current = false;
    }
    setVisibleOutfitFilterModal(false);
    setIsOutfitFilterOpening(!isOutfitFilterOpening);
  };
  const getFilterCount = useMemo(() => {
    const count =
      getSearchCategories().length +
      handleMoreSizeCodeToLessSize(
        searchResult.result.aggregations.sizes,
        getSearchSizes()
      ).length;
    return count > 0 ? count : "";
  }, [getSearchCategories, getSearchSizes, searchResult]);
  const getOutfitFilterCount = useMemo(() => {
    let count = 0;
    if (selectedOutfitGender && selectedOutfitGender !== "All") {
      count += 1;
    }
    if (selectedOutfitHeight) {
      count += 1;
    }
    return count > 0 ? count : "";
  }, [selectedOutfitGender, selectedOutfitHeight]);
  const fetchOutfits = (
    itemIds: string[] = [],
    gender: SelectedGender = "All",
    height = "",
    isReset = false,
    genders = searchResult.result.aggregations.tree.genders
  ) => {
    if (itemIds.length > 0) {
      // pick up top 20
      const pickUpTopTwentyIds = JSON.parse(JSON.stringify(itemIds)).splice(
        0,
        20
      );
      const outfitsParams: GetOutfitArgs = {
        productIds: pickUpTopTwentyIds,
        offset: PAGE_NUM * (outfitPage.current - 1),
        region: appStore.region,
        language: appStore.language
      };
      if (isReset) {
        outfitsParams.offset = 0;
      }
      if (genders && genders.length > 0) {
        const info: { name: string; id: number } | undefined = genders.find(
          (item: { name: string; id: number }) => item.name === gender
        );
        if (info) {
          // const name = info.name.toUpperCase();
          // TODO
          const brand = getBrand().toUpperCase() as "UQ" | "GU";
          const region = getRegionFromUrl().toUpperCase() as any;
          if (GENDER_DICT[brand][region]) {
            Object.keys(GENDER_DICT[brand][region]).forEach(
              (genderKey: string) => {
                const genderCode = GENDER_DICT[brand][region][genderKey];
                if (String(info.id) === String(genderCode)) {
                  if (genderKey === "KIDS_BABY") {
                    outfitsParams.gender = `${OUTFIT_GENDER.KIDS},${OUTFIT_GENDER.BABY}`;
                    // FIXME 询问product 男女兼用 的wording 和id
                  } else {
                    outfitsParams.gender = OUTFIT_GENDER[genderKey];
                  }
                }
              }
            );
          }
          // outfitsParams.gender = OUTFIT_GENDER[name];
        } else if (gender && gender !== "All") {
          // gender value is ether "All" nor "Woman/Man/Kids/Baby",
          // pass gender to api in order to response error
          outfitsParams.gender = gender;
        }
      }
      if (height) {
        const heights: OutfitHeight[] =
          genderHeights.current[
            gender === "All" ? "All" : handleSelectGenderHeight(gender)
          ];
        if (heights.length > 0) {
          const info: OutfitHeight | undefined = heights.find(
            (item: OutfitHeight) => item.value === height
          );
          if (info) {
            outfitsParams.height = info.value;
          }
        }
      }
      outfitsParams.callback = () => {
        changeScroll();
      };
      dispatch(SearchResultActions.setOutfitHasMore(false));
      dispatch(SearchResultActions.fetchOutfits(outfitsParams));
    }
  };
  const changeScroll = () => {
    const outfitScrollTop = sessionStorage.getItem("outfitScrollTop");
    if (outfitScrollTop) {
      const isSafari = isSafariBrowser || isIOS;
      const scrollTop = parseInt(outfitScrollTop, 10);

      if (
        typeof window !== "undefined" &&
        "scrollRestoration" in window.history &&
        !isSafari
      ) {
        setTimeout(() => {
          window.scrollTo(0, scrollTop);
          sessionStorage.removeItem("outfitScrollTop");
        }, 500);
      }
    }
  };
  const isVisiblePage = () => {
    const type = params["*"];
    if (!type || (type && !typeList.includes(type))) {
      dispatch(AppActions.setNotFoundPage(true));
    }
  };
  const clearAllFilter = () => {
    setSelectedSizes([]);
    setSelectedCategories([]);
    setSelectedOutfitGender("All");
    setSelectedOutfitHeight("");
    setIsClickProductTabSort(false);
    setIsClickOutfitTabSort(false);
    defaultPathname = location.pathname;
    defaultSearch = location.search;
  };
  const handlerDotClick = (tagName: string) => {
    dispatch(AppActions.setTagDotActive(false));
    window.localStorage.setItem("isNotUserFirst", "true");
    // set current selected tag name
    selectedTagName.current = tagName;
    // reset sort
    const productDefaultSort = PORDUCT_SORT.SIMILAR;
    setProductSort(productDefaultSort);
    // click same tag not trigger
    if (productName !== tagName) {
      setCookie("tagName", tagName, { path: "/" });
      setProductName(tagName);
      clearAllFilter();
      // deselect size
      setFilteredSizes([
        ...filteredSizes.map((size: any) => ({ ...size, checked: false }))
      ]);
      const visualIndex = searchResult.visualProducts.findIndex(
        (product: any) => product.selectedName === tagName
      );
      if (
        visualIndex > -1 &&
        searchResult.visualProducts[visualIndex].similar_products
      ) {
        const ids = searchResult.visualProducts[
          visualIndex
        ].similar_products.map((product: any) => product.upstream_product_id);
        setProductIds(ids);
        updateProducts([], [], ids, parseInt(productDefaultSort, 10), true);
      }
      if (searchType === RESULT_TAB.ITEM) {
        setProductFilter([], [], PORDUCT_SORT.SIMILAR, true, true);
      }
      if (searchType === RESULT_TAB.OUTFIT) {
        setOutfitFilter("All", "", true, true);
      }
    }
    resetProductCategoriesLength();
  };
  const getFilteredTags = useMemo(() => {
    const tags: any[] = [];
    searchResult.bounds.forEach((bound: Bound) => {
      const points = bound.bounding_poly.normalized_vertices;
      // points x,y
      let x = 0;
      let y = 0;
      points.forEach((position: Point) => {
        x += position.x;
        y += position.y;
      });
      x = parseInt(((x / points.length) * 100).toFixed(0), 10);
      y = parseInt(((y / points.length) * 100).toFixed(0), 10);
      const imgDom = document.querySelector("img[alt='example image']");
      let safeDotWidth = 2.5;
      const dotWidth = 16;
      if (imgDom) {
        safeDotWidth = parseInt(
          ((dotWidth / imgDom.clientHeight) * 100).toFixed(0),
          10
        );
      }
      const currentTags = JSON.parse(JSON.stringify(tags));
      const safePoint = computedSafePoint(currentTags, x, y, safeDotWidth);
      // position
      const postion = safePoint[0] > 50 ? "left" : "right";
      tags.push({
        x: safePoint[0],
        y: safePoint[1],
        title: tagWordingDict[bound.intermediate_categories[0]],
        position: postion,
        selectedName: bound.selectedName,
        isActive: bound.selectedName === productName,
        categorie: bound.intermediate_categories[0]
      });
    });
    return tags;
  }, [searchResult.bounds, productName, tagWordingDict]);

  // input Change
  const setFileData = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      resetProductCategoriesLength();
      if (searchType === RESULT_TAB.ITEM) {
        sendTrackEvent({
          brand: transformBrandForGoogleAnalytics(appStore.brand_name),
          event: TRACK_EVENT,
          eventAction: "Click",
          eventCategory: "IS_Result_Item",
          eventLabel: "ImageSearchTop"
        });
      } else {
        sendTrackEvent({
          brand: transformBrandForGoogleAnalytics(appStore.brand_name),
          event: TRACK_EVENT,
          eventAction: "Click",
          eventCategory: "OS_Result_Outfit",
          eventLabel: "ImageSearchTop"
        });
      }
      // close filter
      // product
      setVisibleCategory(false);
      setVisibleSize(false);
      // outfit
      setVisibleGender(false);
      setVisibleHeight(false);
      // clear tagName in cookies
      if (cookies.tagName) {
        setCookie("tagName", "", { path: "/" });
      }
      const imgFile = e.target.files[0];
      const typeFlag = allowFileTypes.find((value) => value === imgFile.type);
      if (typeFlag) {
        // clear bounds
        dispatch(SearchResultActions.setBounds([]));
        setProductFilter([], [], PORDUCT_SORT.SIMILAR, true, true);
        setOutfitFilter("All", "", true, true);
        // reset sort
        setProductSort(PORDUCT_SORT.SIMILAR);
        // selected item tab
        handleChangeProductTab();
        // clear all  filter (item and outfit)
        clearAllFilter();
        //reset outfitPage
        outfitPage.current = INDEX_PAGE;
        //reset SEND UPLOADED IMAGE SUCCESS status
        dispatch(FeedbackActions.setUploadedImageSuccess(false));
        imageOnLoad(imgFile).then((res: any) => {
          dispatch(ImageSearchActions.setSearchImage(res));
          dispatch(ImageSearchActions.setClickUploadImage(true));
          dispatch(ImageSearchActions.setUploadImageLoading(true));
        });
      } else {
        dispatch(AppActions.setUploadServerErrorModal(true));
      }
      const inputEle: any = document.querySelector("input[type=file]");
      if (inputEle) {
        inputEle.value = null;
      }
    }
  };
  const handlerScrollNext = () => {
    const result = searchResult.outFitResult;
    if (result.similarOutfits.length < result.total) {
      outfitPage.current += 1;
      fetchOutfits(
        getProductItemColorIds(),
        selectedOutfitGender,
        selectedOutfitHeight.value
      );
    }
  };
  const getErrorMessage = () => {
    if (
      searchResult.isFilterSortItemError ||
      searchResult.isFilterSortOutfitError
    ) {
      if (
        searchResult.isChangedItemFilterFlag ||
        searchResult.isChangedOutfitFilterFlag
      ) {
        return `${t("text_error_failed_update_filter_criteria")}`;
      }
      if (
        searchResult.isChangeItemSortFlag ||
        searchResult.isChangeOutfitSortFlag
      ) {
        return `${t("text_error_failed_sort_product")}`;
      }
    }
    return "";
  };
  const similarProducts = useMemo(() => {
    let products = [];
    if (searchResult.visualProducts.length > 0) {
      const info = searchResult.visualProducts.find(
        (prod: any) => prod.selectedName === productName
      );
      if (info) {
        products = info.similar_products;
      }
    }

    return products;
  }, [searchResult.visualProducts, productName]);
  // item set search params
  const setProductFilter = (
    sizes: any[],
    categories: any[],
    sort: string,
    replace = false,
    clickDot = false
  ) => {
    const searchParamList: ParamKeyValuePair[] = [];
    const filterSizes = sizes
      .map((size: any) => ({ ...size, type: TAG_TYPE.SIZE }))
      .sort((sizeA: any, sizeB: any) => sizeA.displayCode - sizeB.displayCode);
    const filterCategories = categories
      .map((size: any) => ({ ...size, type: TAG_TYPE.CATEGORY }))
      .sort((sizeA: any, sizeB: any) => sizeA.id - sizeB.id);
    if (filterCategories.length > 0) {
      searchParamList.push([
        "catId",
        filterCategories.map((category: any) => category.id).join(",")
      ]);
    }
    let _filterSizes: any[];
    if (isClickSizeCheckList) {
      _filterSizes = handleSelectSizeToUrl(
        searchResult.result.aggregations.sizes,
        handleDuplicate(filterSizes, "name")
      );
    } else {
      _filterSizes = filterSizes;
    }
    if (_filterSizes.length > 0) {
      searchParamList.push([
        "sizeCodes",
        _filterSizes.map((size: any) => size.code).join(",")
      ]);
    }
    if (
      (sort === PORDUCT_SORT.SIMILAR || sort === PORDUCT_SORT.RECENCY) &&
      (isClickProductTabSort ||
        (getUrlParamaObjCustom(defaultSearch).sort &&
          defaultPathname.includes("product"))) &&
      !clickDot
    ) {
      searchParamList.push(["sort", sort]);
    }
    setSearchParams(searchParamList, { replace });
  };
  // outfit set search params
  const setOutfitFilter = (
    gender: string,
    height: any,
    replace = false,
    clickDot = false
  ) => {
    const searchParamList: ParamKeyValuePair[] = [];
    if (gender && gender !== "All") {
      searchParamList.push(["gender", gender]);
    }
    if (height.value) {
      const isJpJa = params.region === "jp" && params.language === "ja";
      const minHeight = height.min ? height.min : "1";
      let maxHeight;
      if (!height.max && isJpJa) {
        maxHeight = "300";
      } else if (!height.max && !isJpJa) {
        maxHeight = "118";
      } else {
        maxHeight = height.max;
      }
      searchParamList.push(["height", `${minHeight}-${maxHeight}`]);
    }
    if (
      (isClickOutfitTabSort ||
        (getUrlParamaObjCustom(defaultSearch).order &&
          defaultPathname.includes("outfit"))) &&
      !clickDot
    ) {
      searchParamList.push(["order", "display_start_at"]);
    }
    setSearchParams(searchParamList, { replace });
  };
  const expandItemFilterOnRefresh = () => {
    if (selectedSizes.length > 0 || getSearchSizes().length > 0) {
      setVisibleSize(true);
    }
    if (selectedCategories.length > 0 || getSearchCategories().length > 0) {
      setVisibleCategory(true);
    }
  };
  const expandOutfitFilterOnRefresh = () => {
    if (!!getSearchHeight() || !!selectedOutfitHeight) {
      setVisibleHeight(true);
    }
    if (
      (getSearchGender() && getSearchGender() !== "All") ||
      (selectedOutfitGender && selectedOutfitGender !== "All")
    ) {
      setVisibleGender(true);
    }
  };
  const getOutfitHeights = () =>
    (searchResult.result.aggregations.tree[CATEGORY_TYPE.GENDERS]
      ? genderHeights.current[
          selectedOutfitGender === "All"
            ? "All"
            : handleSelectGenderHeight(selectedOutfitGender)
        ]
      : []) || [];
  const getOutfitGenders = () =>
    searchResult.result.aggregations.tree[CATEGORY_TYPE.GENDERS] || [];
  const getSearchTypeIndex = () => (searchType === RESULT_TAB.ITEM ? 0 : 1);
  const getProductTotalText = () =>
    searchResult.resultItemloading
      ? "-"
      : formatTotalNum(
          params.language || "ja",
          searchResult.result.pagination.total
        );
  const getOutfitTotalText = () =>
    searchResult.visibleOutfitloading
      ? "-"
      : formatTotalNum(
          params.language || "ja",
          searchResult.outFitResult.total
        );
  const historyBackGoTop = () => {
    if (isSearchTypeFirst.current) {
      isSearchTypeFirst.current = false;
    } else {
      goTopPage();
    }
  };
  // filter product sizes when active is true
  const filteredActivedSizes = useMemo(
    () =>
      searchResult.result.aggregations.sizes.filter(
        (size: any) => size.display.showFlag
      ),
    [searchResult.result.aggregations.sizes]
  );
  // validate router
  isVisiblePage();
  useEffect(() => {
    // set cache tag name
    let defaultIndex = 0;
    const cacheTagName = cookies.tagName;
    if (cacheTagName) {
      const cacheIndex = searchResult.bounds.findIndex(
        (bound: any) => bound.selectedName === cacheTagName
      );
      if (cacheIndex > -1) {
        defaultIndex = cacheIndex;
      }
    }
    if (searchResult.bounds.length > 0 && searchResult.bounds[defaultIndex]) {
      setProductName(searchResult.bounds[defaultIndex].selectedName);
    }
  }, [searchResult.bounds.length]);
  useEffect(() => {
    const visualIndex = searchResult.visualProducts.findIndex(
      (product: any) => product.selectedName === productName
    );
    if (
      visualIndex > -1 &&
      searchResult.visualProducts[visualIndex].similar_products
    ) {
      const ids = searchResult.visualProducts[visualIndex].similar_products.map(
        (product: any) => product.upstream_product_id
      );
      setProductIds(ids);
    } else {
      setProductIds([]);
    }
  }, [searchResult.visualProducts, productName]);

  const initVisualSearch = async () => {
    let file: any = paramImage;
    const imageUrl = window.URL.createObjectURL(
      new Blob([file], { type: "image/jpeg" })
    );
    // creat image url to show image
    if (paramImage && paramImage.type === "image/gif") {
      changeFileType(paramImage).then((res) => {
        if (res) {
          fileToBase64(res as any).then((url) => {
            setImgUrl(url);
          });
        }
      });
    } else {
      setImgUrl(imageUrl);
    }

    if (file) {
      // scroll top
      if (
        typeof window !== "undefined" &&
        "scrollRestoration" in window.history &&
        !(window.navigator.userAgent.indexOf("safari") > -1)
      ) {
        window.history.scrollRestoration = "manual";
        window.scrollTo(0, 0);
      }
      setIsImageLoad(false);
      dispatch(SearchResultActions.setItemLoadingStatus(true));
      dispatch(SearchResultActions.setOutfitLoadingStatus(true));
      dispatch(ImageSearchActions.setUploadImageLoading(false));
      // set image to upload

      const getFirebaseResult = await getVisualSearchMinScoreConfig();
      if (getFirebaseResult && getFirebaseResult.minScore) {
        minScore.current = getFirebaseResult.minScore;
      }
      if (getFirebaseResult && getFirebaseResult.imagesearch_wish) {
        isShowOutfitWishIcon.current = JSON.parse(
          getFirebaseResult.imagesearch_wish
        ).icon;
      }
      selectedTagName.current = "";
      dispatch(
        SearchResultActions.fetchVisualSearch({
          minScore: minScore.current,
          image: paramImage,
          callback: (productsIds: any[], products: any[]) => {
            visualProducts.current = products;
            const fetchProductsParams: GetProductsArgs = {
              productsIds: productsIds,
              path: getSearchCategories(),
              sizeCodes: getSearchSizes(),
              sort: getSearchSort(),
              callback: initSelectedTags
            };
            dispatch(SearchResultActions.fetchProducts(fetchProductsParams));
          },
          // default tagname from cookies
          tagName: cookies.tagName
        })
      );
    } else {
      base64ToFile(localStorage.getItem("searchImage")).then((image) => {
        file = image;
        dispatch(
          ImageSearchActions.setSearchImage({
            image: image
          })
        );
      });
    }
  };
  const pageAccessedByReload =
    window.performance.navigation &&
    performance.navigation.type === performance.navigation.TYPE_RELOAD;
  const pageBackUpdate = () => {
    // 从outfit 详情页面返回后再次点击返回到这个页面时 清除search params
    if (!pageAccessedByReload && jumpCookies.jumpFrom === "outfit") {
      setSearchParams([], { replace: true });
      setVisibleSize(false);
      setVisibleCategory(false);
    } else {
      expandItemFilterOnRefresh();
    }
    setJumpFrom("jumpFrom", "", { path: "/" });
  };

  const pillContentProps = useMemo(() => {
    const getSizeFilterLabel = () => {
      if (selectedSizes.length > 0 && selectedSizes.length === 1) {
        return head(selectedSizes)?.name;
      }
      if (selectedSizes.length > 1) {
        return `${head(selectedSizes)?.name}...`;
      }
      return t("text_size");
    };

    return {
      tree: searchResult.result.aggregations.tree,
      genderName:
        selectedCategories.length > 0
          ? head(selectedCategories)?.name
          : t("text_gender"),
      categoryLabel:
        selectedCategories.length > 1
          ? last(selectedCategories)?.name
          : t("text_category"),
      sizeFilterLabel: getSizeFilterLabel(),
      sizes: filteredActivedSizes,
      selectedSizes,
      filteredSizes,
      selectedCategories,
      setIsClickSizeCheckList,
      onChangeSelectedSizes: handlerChangeSelectedSizes,
      setFilteredSizes: setSortFilteredSizes,
      categoryType: searchResult.categoryType,
      searchCategories: getSearchCategories(),
      onChangeSelectedCategories: handlerSelectedCategories

      // pathLength:selectedCategories.length || getSearchCategories().length
    };
  }, [params, selectedCategories, selectedSizes, searchResult, filteredSizes]);

  const outfitTabPillConentProps = useMemo(
    () => ({
      tree: searchResult.result.aggregations.tree,
      genderName:
        selectedCategories.length > 0
          ? head(selectedCategories)?.name
          : t("text_gender"),
      genderFilterLabel:
        selectedOutfitGender === "All"
          ? t("text_category")
          : selectedOutfitGender,
      heightFilterLabel: selectedOutfitHeight
        ? handleHeightLabel(selectedOutfitHeight, t)
        : t("text_height"),
      selectedCategories,
      selectedSizes,
      genders: getOutfitGenders(),
      heights: getOutfitHeights(),
      selectedHeight: selectedOutfitHeight,
      selectedGender: selectedOutfitGender,
      onChangeSelected: handlerOutfitSelected
    }),
    [
      params,
      selectedCategories,
      selectedSizes,
      filteredSizes,
      selectedOutfitGender,
      selectedOutfitHeight
    ]
  );

  useEffect(() => {
    initVisualSearch();
  }, [dispatch, paramImage]);
  useEffect(() => {
    if (params["*"] === RESULT_TAB.ITEM) {
      setSearchType(RESULT_TAB.ITEM);
      pageBackUpdate();
    }
    if (params["*"] === RESULT_TAB.OUTFIT) {
      setSearchType(RESULT_TAB.OUTFIT);
      expandOutfitFilterOnRefresh();
    }
  }, [params]);
  useEffect(() => {
    historyBackGoTop();
    if (searchType === RESULT_TAB.ITEM) {
      if (
        selectedSizes.length > 0 ||
        selectedCategories.length > 0 ||
        (productSort === "0" && isClickProductTabSort) ||
        productSort === "1"
      ) {
        setProductFilter(selectedSizes, selectedCategories, productSort, true);
      }
    }
    if (searchType === RESULT_TAB.OUTFIT) {
      if (
        (selectedOutfitGender && selectedOutfitGender !== "All") ||
        selectedOutfitHeight ||
        (outfitSort === "display_start_at" && isClickOutfitTabSort)
      ) {
        setOutfitFilter(selectedOutfitGender, selectedOutfitHeight, true);
      }
    }
  }, [searchType, isClickProductTabSort, isClickOutfitTabSort]);

  useEffect(() => {
    if (
      isClickUploadImage &&
      !isUploadImageLoading &&
      !searchResult.resultItemloading
    ) {
      dispatch(ImageSearchActions.setClickUploadImage(false));
      // search_26v2 GA event
      trackSearchClickEvent(searchResult.result.pagination.total);
    }
  }, [
    searchResult.result.pagination.total,
    isClickUploadImage,
    searchResult.resultItemloading
  ]);

  return (
    <>
      <Helmet
        titleTemplate={t("text_image_search_result_meta_title")}
        defaultTitle={t("text_image_search_result_meta_title")}
        htmlAttributes={{ lang: appStore.language }}
      >
        <meta
          property="og:title"
          content={t("text_image_search_result_meta_title")}
        />
        <meta
          name="description"
          content={t("text_image_search_result_meta_description")}
        />
        <meta property="og:site_name" content={getBrandForMeta()} />
        <meta
          property="og:title"
          content={t("text_image_search_result_meta_title")}
        />
        <meta property="og:description" content={""} />
        <meta property="og:image" content={""} />
        <meta property="fb:app_id" content={""} />
        <meta name="twitter:card" content={"summary"} />
        <meta name="twitter:site" content={getBrandForMeta()} />
        <meta
          name="twitter:title"
          content={t("text_image_search_meta_title")}
        />
        <meta name="twitter:image" content={""} />
        <meta
          property="og:url"
          content={`${window.origin}${BASE_PATH_NAME}/image-search`}
        />
      </Helmet>
      <Layout
        colSpan={{
          lg: 12,
          md: 12,
          sm: 4
        }}
        element="div"
        className={style.search_result}
      >
        <ProductTabNewFilter
          visible={isFilterOpening}
          total={getProductTotalText()}
          tree={searchResult.result.aggregations.tree}
          sizes={filteredActivedSizes}
          visibleSize={visibleSize}
          visibleCategory={visibleCategory}
          searchCategories={getSearchCategories()}
          searchSizes={getSearchSizes()}
          filteredSizes={filteredSizes}
          categoryType={searchResult.categoryType}
          selectedSizes={selectedSizes}
          selectedCategories={selectedCategories}
          onChangeSelectedSizes={handlerChangeSelectedSizes}
          onChangeSelectedCategories={handlerSelectedCategories}
          handlerSizeExpand={handlerSizeExpand}
          handlerCategoryExpand={handlerCategoryExpand}
          handlerClearAllFilter={handlerClearAllItemFilter}
          setFilteredSizes={setSortFilteredSizes}
          onClose={closeFilterModel}
          setIsClickSizeCheckList={setIsClickSizeCheckList}
        />
        <OutfitTabNewFilter
          visible={isOutfitFilterOpening}
          total={getOutfitTotalText()}
          tree={searchResult.result.aggregations.tree}
          sizes={filteredActivedSizes}
          visibleSize={visibleSize}
          visibleCategory={visibleCategory}
          searchCategories={getSearchCategories()}
          searchSizes={getSearchSizes()}
          filteredSizes={filteredSizes}
          categoryType={searchResult.categoryType}
          selectedSizes={selectedSizes}
          selectedCategories={selectedCategories}
          onChangeSelectedSizes={handlerChangeSelectedSizes}
          onChangeSelectedCategories={handlerSelectedCategories}
          handlerSizeExpand={handlerSizeExpand}
          handlerCategoryExpand={handlerCategoryExpand}
          handlerClearAllFilter={handlerClearAllItemFilter}
          setFilteredSizes={setSortFilteredSizes}
          onClose={closeOutfitFilterModel}
          setIsClickSizeCheckList={setIsClickSizeCheckList}
          genders={getOutfitGenders()}
          selectedGender={selectedOutfitGender}
          selectedHeight={selectedOutfitHeight}
          onChangeSelected={handlerOutfitSelected}
          heights={getOutfitHeights()}
        />
        {appStore.isVisibleLogin && <LoginModal />}
        {appStore.isVisibleErrorModal && <ServerErrorModal />}
        {appStore.isVisibleUploadErrorModal && <UploadServerErrorModel />}
        {feedbackStore.isVisibleFeedbackModal && <FeedBackModal />}
        {isPopupShown && (
          <FavoritesPopup
            closePopup={() => setIsPopupShown(false)}
            productInfo={currentItemInfo.productInfo}
            modelWearingColor={
              getEcRenewalCompatibility()
                ? currentItemInfo.productInfo?.color?.code
                : null
            }
          />
        )}
        <Layout
          colSpan={{
            lg: 12,
            md: 12,
            sm: 4
          }}
          element="div"
        >
          <HeaderPage
            hideKeyline
            captions={[]}
            errors={[getErrorMessage()]}
            labelElement="p"
            textLink={undefined}
            title={t("text_image_search")}
            toolTip={undefined}
          />
        </Layout>
        <Keyline className="fr-ec-mb-spacing-05" />
        <Layout className={style.search_result_image}>
          <GutterContainer>
            <ImageEnhancements
              absolutePositionContent={
                <ItemTags
                  pulseEffect={appStore.isTagDotActive}
                  variant="imageSearch"
                >
                  {getFilteredTags.map((tag: any) => (
                    <ItemTag
                      key={tag.selectedName}
                      isActive={tag.isActive}
                      dotOnClick={() => {
                        handlerDotClick(tag.selectedName);
                      }}
                      labelTitle={tag.title}
                      popupPosition={tag.position}
                      positionCoordinates={[tag.x, tag.y]}
                      toggleArrow={false}
                    />
                  ))}
                </ItemTags>
              }
              bottomTextColor={{
                left: "black",
                right: "black"
              }}
              padding
              topTextColor={{
                left: "black",
                right: "black"
              }}
            >
              <ImageComponent
                alt="styling image"
                disabled={false}
                onLoad={imageLoaded}
                ratio="full-width"
                src={imgUrl}
                unavailable={false}
                className="fr-ec-mb-spacing-04"
              />
            </ImageEnhancements>
          </GutterContainer>
          <GutterContainer className="fr-ec-mb-spacing-05">
            <FileInput
              accept="image/jpg,image/jpeg,image/png,image/webp,image/gif"
              icon="visual-search"
              label={t("text_image_search_change_image_link")}
              variant="link"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setFileData(e)
              }
            />
          </GutterContainer>
          <Layout
            element="div"
            visible={{
              lg: true,
              md: false,
              sm: false
            }}
            className={style.search_result_filter}
          >
            {/* {getPcFilter()} */}
            <Spacer element="div" variant={"spacing-08"} />
          </Layout>
        </Layout>
        <Layout className={style.search_result_tab}>
          {!searchResult.visualSearchNoData ||
          searchResult.resultItemloading ? (
            <TabGroup
              variant="standard"
              genderTypography={false}
              defaultIndex={getSearchTypeIndex()}
              className={
                getEcRenewalCompatibility() ? "fr-ec-mb-spacing-02" : ""
              }
            >
              <Tab
                id={RESULT_TAB.ITEM}
                label={t("text_image_search_item_tab")}
                variant="gender"
                onClick={() => {
                  sendTrackEvent({
                    brand: transformBrandForGoogleAnalytics(
                      appStore.brand_name
                    ),
                    event: TRACK_EVENT,
                    eventAction: "Click",
                    eventCategory: "OS_Result_Outfit",
                    eventLabel: "ItemTab"
                  });
                  handleChangeProductTab();
                  if (searchResult.result.pagination.total > 0) {
                    // item Categories
                    let newSelectedCategories: any = selectedCategories;
                    newSelectedCategories = newSelectedCategories.map(
                      (item: any) => item.name
                    );
                    // item sizes
                    let newSelectedSizes: any[] = selectedSizes;
                    newSelectedSizes = newSelectedSizes.map(
                      (item) => item.name
                    );
                    if (
                      newSelectedCategories.length > 0 &&
                      newSelectedSizes.length > 0
                    ) {
                      sendTrackEvent({
                        brand: transformBrandForGoogleAnalytics(
                          appStore.brand_name
                        ),
                        event: TRACK_EVENT_SEARCH,
                        eventAction: "IS_Item_WithFilter",
                        eventCategory: "IS_Result",
                        eventLabel: `Search term: ${newSelectedCategories.join(
                          ","
                        )},${newSelectedSizes.join(",")}`,
                        searchTerm: `${newSelectedCategories.join(
                          ","
                        )},${newSelectedSizes.join(",")}`,
                        resultsNumber: `${searchResult.result.pagination.total}`
                      });
                    } else if (newSelectedCategories.length > 0) {
                      sendTrackEvent({
                        brand: transformBrandForGoogleAnalytics(
                          appStore.brand_name
                        ),
                        event: TRACK_EVENT_SEARCH,
                        eventAction: "IS_Item_WithFilter",
                        eventCategory: "IS_Result",
                        eventLabel: `Search term: ${newSelectedCategories.join(
                          ","
                        )}`,
                        searchTerm: `${newSelectedCategories.join(",")}`,
                        resultsNumber: `${searchResult.result.pagination.total}`
                      });
                    } else if (newSelectedSizes.length > 0) {
                      sendTrackEvent({
                        brand: transformBrandForGoogleAnalytics(
                          appStore.brand_name
                        ),
                        event: TRACK_EVENT_SEARCH,
                        eventAction: "IS_Item_WithFilter",
                        eventCategory: "IS_Result",
                        eventLabel: `Search term: ${newSelectedSizes.join(
                          ","
                        )}`,
                        searchTerm: `${newSelectedSizes.join(",")}`,
                        resultsNumber: `${searchResult.result.pagination.total}`
                      });
                    } else {
                      sendTrackEvent({
                        brand: transformBrandForGoogleAnalytics(
                          appStore.brand_name
                        ),
                        event: TRACK_EVENT_SEARCH,
                        eventAction: "IS_Item_WithoutFilter",
                        eventCategory: "IS_Result",
                        eventLabel: "Search term:",
                        searchTerm: null,
                        resultsNumber: `${searchResult.result.pagination.total}`
                      });
                    }
                  } else if (!searchResult.result.initFlag) {
                    sendTrackEvent({
                      brand: transformBrandForGoogleAnalytics(
                        appStore.brand_name
                      ),
                      event: TRACK_EVENT,
                      eventAction: "IS_Item_NotFound",
                      eventCategory: "IS_Result",
                      eventLabel: "Search term:"
                    });
                  }
                }}
                // isActive={searchType === RESULT_TAB.ITEM}
              >
                <Routes>
                  <Route
                    path={"product"}
                    element={
                      <ProductList
                        visible={
                          !(
                            searchResult.result.pagination.count === 0 &&
                            selectedCategories.length === 0 &&
                            selectedSizes.length === 0
                          ) && !searchResult.resultItemloading
                        }
                        onToggleFilter={handlerToggleFilter}
                        currentSort={productSort}
                        onChangeSort={handlerChangeSort}
                        filterCount={
                          !searchResult.resultItemloading ? getFilterCount : ""
                        }
                        onClickFavorite={handlerFavoriteClick}
                        products={searchResult.result.items}
                        total={getProductTotalText()}
                        isImageLoad={isImageLoad}
                        similarProducts={similarProducts}
                        setIsClickProductTabSort={setIsClickProductTabSort}
                        filterPillContent={getProductTabFilterPillContent(
                          pillContentProps
                        )}
                      />
                    }
                  />
                </Routes>
              </Tab>
              <Tab
                id={RESULT_TAB.OUTFIT}
                label={t("text_image_search_outfit_tab")}
                onClick={() => {
                  sendTrackEvent({
                    brand: transformBrandForGoogleAnalytics(
                      appStore.brand_name
                    ),
                    event: TRACK_EVENT,
                    eventAction: "Click",
                    eventCategory: "IS_Result_Item",
                    eventLabel: "OutfitTab"
                  });
                  handleChangeStylingTab();
                  if (searchResult.outFitResult.total > 0) {
                    const searchGender = selectedOutfitGender;
                    const searchHeight = selectedOutfitHeight;
                    const fetchParams: {
                      gender: SelectedGender;
                      height: string;
                    } = {
                      gender: "All",
                      height: ""
                    };
                    if (searchGender && searchGender !== "All") {
                      fetchParams.gender = searchGender as SelectedGender;
                    }
                    if (searchHeight) {
                      fetchParams.height = handleHeightLabel(searchHeight, t);
                    }
                    if (fetchParams.gender !== "All" && fetchParams.height) {
                      sendTrackEvent({
                        brand: transformBrandForGoogleAnalytics(
                          appStore.brand_name
                        ),
                        event: TRACK_EVENT_SEARCH,
                        eventAction: "IS_Outfit_WithFilter",
                        eventCategory: "OS_Result",
                        eventLabel: `Search term: ${fetchParams.gender},${fetchParams.height}`,
                        searchTerm: `${fetchParams.gender},${fetchParams.height}`,
                        resultsNumber: `${searchResult.outFitResult.total}`
                      });
                    } else if (fetchParams.gender !== "All") {
                      sendTrackEvent({
                        brand: transformBrandForGoogleAnalytics(
                          appStore.brand_name
                        ),
                        event: TRACK_EVENT_SEARCH,
                        eventAction: "IS_Outfit_WithFilter",
                        eventCategory: "OS_Result",
                        eventLabel: `Search term: ${fetchParams.gender}`,
                        searchTerm: `${fetchParams.gender}`,
                        resultsNumber: `${searchResult.outFitResult.total}`
                      });
                    } else if (fetchParams.height) {
                      sendTrackEvent({
                        brand: transformBrandForGoogleAnalytics(
                          appStore.brand_name
                        ),
                        event: TRACK_EVENT_SEARCH,
                        eventAction: "IS_Outfit_WithFilter",
                        eventCategory: "OS_Result",
                        eventLabel: `Search term: ${fetchParams.height}`,
                        searchTerm: `${fetchParams.height}`,
                        resultsNumber: `${searchResult.outFitResult.total}`
                      });
                    } else {
                      sendTrackEvent({
                        brand: transformBrandForGoogleAnalytics(
                          appStore.brand_name
                        ),
                        event: TRACK_EVENT_SEARCH,
                        eventAction: "IS_Outfit_WithoutFilter",
                        eventCategory: "OS_Result",
                        eventLabel: "Search term:",
                        searchTerm: null,
                        resultsNumber: `${searchResult.outFitResult.total}`
                      });
                    }
                  } else if (!searchResult.result.initFlag) {
                    sendTrackEvent({
                      brand: transformBrandForGoogleAnalytics(
                        appStore.brand_name
                      ),
                      event: TRACK_EVENT,
                      eventAction: "IS_Outfit_NotFound",
                      eventCategory: "OS_Result",
                      eventLabel: "Search term:"
                    });
                  }
                }}
                // isActive={searchType === RESULT_TAB.OUTFIT}
              >
                <Routes>
                  <Route
                    path={"outfit"}
                    element={
                      <OutfitList
                        visible={
                          !(
                            searchResult.outFitResult.total === 0 &&
                            selectedOutfitGender === "All" &&
                            selectedOutfitHeight === "" &&
                            !searchResult.visibleOutfitloading
                          )
                        }
                        hasMore={searchResult.outfitHasMore}
                        handlerScrollNext={handlerScrollNext}
                        isLoading={searchResult.visibleOutfitloading}
                        isScrollNextPageLoading={
                          searchResult.visibleOutfitHasNextPageLoading
                        }
                        outfits={searchResult.outFitResult.similarOutfits}
                        searchResult={searchResult}
                        total={getOutfitTotalText()}
                        filterCount={
                          !searchResult.visibleOutfitloading
                            ? getOutfitFilterCount
                            : ""
                        }
                        handleClearAll={() => {
                          handlerOutfitSelected("All", "", false);
                        }}
                        onChangeSort={handlerChangeOutfitSort}
                        onToggleFilter={handlerToggleOutfitFilter}
                        handleClickStyleFavorite={handlerClickStyleFavorite}
                        isImageLoad={isImageLoad}
                        setIsClickOutfitTabSort={setIsClickOutfitTabSort}
                        isShowOutfitWishIcon={isShowOutfitWishIcon.current}
                        filterPillContent={
                          // !(
                          //   searchResult.outFitResult.total === 0 &&
                          //   selectedOutfitGender === "All" &&
                          //   selectedOutfitHeight === "" &&
                          //   !searchResult.visibleOutfitloading
                          // )
                          //   ? getOutfitTabFilterPillContent(
                          //       outfitTabPillConentProps
                          //     )
                          //   : null
                          getOutfitTabFilterPillContent(
                            outfitTabPillConentProps
                          )
                        }
                      />
                    }
                  />
                </Routes>
              </Tab>
            </TabGroup>
          ) : (
            <NoResult />
          )}
        </Layout>
        <FilterModel
          visible={visibleFilterModal}
          total={getProductTotalText()}
          tree={searchResult.result.aggregations.tree}
          sizes={filteredActivedSizes}
          visibleSize={visibleSize}
          visibleCategory={visibleCategory}
          searchCategories={getSearchCategories()}
          searchSizes={getSearchSizes()}
          filteredSizes={filteredSizes}
          categoryType={searchResult.categoryType}
          selectedSizes={selectedSizes}
          selectedCategories={selectedCategories}
          onChangeSelectedSizes={handlerChangeSelectedSizes}
          onChangeSelectedCategories={handlerSelectedCategories}
          handlerSizeExpand={handlerSizeExpand}
          handlerCategoryExpand={handlerCategoryExpand}
          handlerClearAllFilter={handlerClearAllItemFilter}
          setFilteredSizes={setSortFilteredSizes}
          onClose={closeFilterModel}
          setIsClickSizeCheckList={setIsClickSizeCheckList}
        />
        <OutfitFilterModel
          visibleFilter={
            searchResult.outFitResult.total === 0 &&
            getSearchGender().length === 0 &&
            getSearchHeight().length === 0 &&
            selectedOutfitGender === "All" &&
            selectedOutfitHeight === ""
          }
          visible={visibleOutfitFilterModal}
          total={getOutfitTotalText()}
          genders={getOutfitGenders()}
          heights={getOutfitHeights()}
          visibleGender={visibleGender}
          visibleHeight={visibleHeight}
          searchGender={getSearchGender()}
          searchHeight={getSearchHeight()}
          selectedGender={selectedOutfitGender}
          selectedHeight={selectedOutfitHeight}
          onChangeSelected={handlerOutfitSelected}
          handlerGenderExpand={handlerGenderExpand}
          handlerHeightExpand={handlerHeightExpand}
          onClose={closeOutfitFilterModel}
        />
        {/* <GoTop /> */}
        {feedbackStore.isUploadedImageSuccess && (
          <Toast
            autoClose
            element="a"
            linkTextLabel=""
            variant="dark"
            autoCloseDelay={2000}
          >
            {t(
              "text_image_search_no_result_send_uploaded_image_complete_thanks"
            )}
          </Toast>
        )}
      </Layout>
    </>
  );
};
export default withBreadcrumb(SearchResult);
